import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import CountUp from "react-countup";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import Flatpickr from "react-flatpickr";

import SimpleBar from "simplebar-react";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../store/app/action";
import { getUom, addNewUom } from "../../store/uom/action";
import { getBudget as onGetBudgets, addNewBudget as onAddNewBudget, updateBudget as onUpdateBudget, deleteBudget as onDeleteBudget, getBudgetLoading, resetBudgetState } from "../../store/budget/action";

import { api } from "../../config";
import ModalInputFile from "../../Components/ModalInputFile";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import handleValidDate from "../../helpers/utils/handleValidDate";
import ModalImage from "react-modal-image";
import ExportDoc from "../../Components/Common/ExportDoc";
import ExportBudgetDoc from "./ExportBudgetDoc";

const Budget = () => {
  const [pIndexSecond, setPIndexSecond] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [mediaType, setMediaType] = useState("");
  const [info, setInfo] = useState([]);
  const [infoList, setInfoList] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, budgets, isBudgetCreated, isBudgetSuccess, loading, error, companies, companyLoading, clients, clientLoading, branches, branchLoading, uoms, uomLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    budgets: state.Budget.budgets,
    loading: state.Budget.loading,
    isBudgetCreated: state.Budget.isBudgetCreated,
    isBudgetSuccess: state.Budget.isBudgetSuccess,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.Budget.error,
    uoms: state.Uom.uoms,
    uomLoading: state.Uom.loading,
  }));

  const [budgetList, setBudgetList] = useState([]);
  const [accTrans, setAccTrans] = useState([]);
  const [totalCashIn, setTotalCashIn] = useState(0);
  const [totalIn, setTotalIn] = useState(0);
  const [totalInRec, setTotalInRec] = useState(0);
  const [totalRealizationIn, setTotalRealizationIn] = useState(0);
  const [totalSaldoIn, setTotalSaldoIn] = useState(0);
  const [totalCashOut, setTotalCashOut] = useState(0);
  const [totalOut, setTotalOut] = useState(0);
  const [totalOutPay, setTotalOutPay] = useState(0);
  const [totalRealizationOut, setTotalRealizationOut] = useState(0);
  const [totalSaldoOut, setTotalSaldoOut] = useState(0);

  const [budgetCashInList, setBudgetCashInList] = useState([]);
  const [budgetCashOutList, setBudgetCashOutList] = useState([]);
  const [budget, setBudget] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [uomList, setUomList] = useState([]);

  const [printDoc, setPrintDoc] = useState([]);
  const [printDoc2, setPrintDoc2] = useState([]);

  const [printDetailDoc, setPrintDetailDoc] = useState([]);
  const [typeBudget, setTypeBudget] = useState({ label: "PENERIMAAN KAS", value: "CASH IN" });

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const transTypeData = [
    {
      options: [
        { label: "PENERIMAAN KAS", value: "CASH IN" },
        { label: "PENGELUARAN KAS", value: "CASH OUT" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [inputDate, setInputDate] = useState("");

  const onClickDelete = (budget) => {
    setBudget(budget);
    setDeleteModal(true);
  };

  const handleDeleteBudget = () => {
    if (budget) {
      dispatch(onDeleteBudget(budget));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(resetBudgetState());
      dispatch(onGetBudgets({ companyId: companySelected?.value ?? "", branchId: branchSelected?.value ?? "" }));
      handleGetUOM(companySelected?.value ?? "");
      setIsEdit(false);
    }
  }, [branchSelected, companySelected]);

  const handleGetUOM = (companyId) => {
    dispatch(getUom({ companyId: companyId, status: 2 }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(onGetBudgets({ companyId: companyId, branchId: branchId }));
  };

  useEffect(() => {
    if (!isEmpty(budgets)) {
      let arrCashIn = [];
      let arrCashOut = [];
      let tin = 0;
      let trin = 0;
      let tinrec = 0;
      let tcin = 0;
      let tsin = 0;
      let tout = 0;
      let tcout = 0;
      let trout = 0;
      let toutpay = 0;
      let tsout = 0;
      for (const budget of budgets) {
        if (budget.type === "CASH IN") {
          arrCashIn.push(budget);
          tin += parseFloat(budget.total, 2);
          trin +=
            (budget.budget_acc_trans || [])
              .filter((item) => item.type === "CASH IN")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0) +
            (budget.budget_acc_trans || [])
              .filter((item) => item.type === "RECEIVABLE")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0);
          tcin += (budget.budget_acc_trans || [])
            .filter((item) => item.type === "CASH IN")
            .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
            .reduce((prev, curr) => prev + curr, 0);
          tinrec += (budget.budget_acc_trans || [])
            .filter((item) => item.type === "RECEIVABLE")
            .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
            .reduce((prev, curr) => prev + curr, 0);
          tsin += parseFloat(budget.total) - (budget.budget_acc_trans || []).map((el) => parseFloat(el.amount - (el.paid_amount || 0))).reduce((prev, curr) => prev + curr, 0);
        } else {
          arrCashOut.push(budget);
          tout += parseFloat(budget.total, 2);
          trout +=
            (budget.budget_acc_trans || [])
              .filter((item) => item.type === "CASH OUT")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0) +
            (budget.budget_acc_trans || [])
              .filter((item) => item.type === "PAYABLE")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0);
          tcout += (budget.budget_acc_trans || [])
            .filter((item) => item.type === "CASH OUT")
            .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
            .reduce((prev, curr) => prev + curr, 0);
          toutpay += (budget.budget_acc_trans || [])
            .filter((item) => item.type === "PAYABLE")
            .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
            .reduce((prev, curr) => prev + curr, 0);
          tsout += parseFloat(budget.total) - (budget.budget_acc_trans || []).map((el) => parseFloat(el.amount - (el.paid_amount || 0))).reduce((prev, curr) => prev + curr, 0);
        }
      }
      setBudgetList(budgets);
      setTotalCashIn(tin);
      setTotalIn(tcin);
      setTotalInRec(tinrec);
      setTotalRealizationIn(trin);
      setTotalSaldoIn(tsin);
      setTotalCashOut(tout);
      setTotalOut(tcout);
      setTotalOutPay(toutpay);
      setTotalRealizationOut(trout);
      setTotalSaldoOut(tsout);
      setBudgetCashInList(arrCashIn.map((el) => ({ ...el, isChecked: false })).sort((a, b) => a.code - b.code));
      setBudgetCashOutList(arrCashOut.map((el) => ({ ...el, isChecked: false })).sort((a, b) => a.code - b.code));
      setBudget(budgets);
    } else {
      setBudgetList([]);
      setTotalCashIn(0);
      setTotalIn(0);
      setTotalInRec(0);
      setTotalRealizationIn(0);
      setTotalSaldoIn(0);
      setTotalCashOut(0);
      setTotalOut(0);
      setTotalOutPay(0);
      setTotalRealizationOut(0);
      setTotalSaldoOut(0);
      setBudgetCashInList([]);
      setBudgetCashOutList([]);
      setBudget({});
    }
  }, [budgets]);

  const init = [
    {
      id: "name",
      label: "Budget",
      isSelected: true,
      data: [],
    },
    {
      id: "budget_branch",
      label: "Proyek",
      isSelected: true,
      data: [],
    },
    {
      id: "quantity",
      label: "Qty",
      isSelected: true,
      data: [],
    },
    {
      id: "amount",
      label: "Harga",
      isSelected: true,
      data: [],
    },
    {
      id: "total",
      label: "Total",
      isSelected: true,
      data: [],
    },
    {
      id: "kas_masuk",
      label: "Kas Masuk",
      isSelected: true,
      data: [],
    },
    {
      id: "kas_keluar",
      label: "Kas Keluar",
      isSelected: true,
      data: [],
    },
    {
      id: "sisa_piutang",
      label: "Sisa Piutang",
      isSelected: true,
      data: [],
    },
    {
      id: "sisa_hutang",
      label: "Sisa Hutang",
      isSelected: true,
      data: [],
    },
    {
      id: "realisasi",
      label: "Realisasi",
      isSelected: true,
      data: [],
    },
    {
      id: "sisa",
      label: "Sisa",
      isSelected: true,
      data: [],
    },
    ///colum detail
    {
      id: "no_detail",
      label: "No Transaksi",
      isSelected: true,
      data: [],
    },
    {
      id: "tgl_detail",
      label: "Tanggal",
      isSelected: true,
      data: [],
    },
    {
      id: "jenis_detail",
      label: "Jenis",
      isSelected: true,
      data: [],
    },
    {
      id: "tag_detail",
      label: "Tag",
      isSelected: true,
      data: [],
    },
    {
      id: "jumlah_detail",
      label: "Jumlah Pembayaran",
      isSelected: true,
      data: [],
    },
    {
      id: "description_detail",
      label: "Keterangan",
      isSelected: true,
      data: [],
    },
  ];

  useEffect(() => {
    let dataDoc = init;

    const merged = [...budgetCashInList, ...budgetCashOutList];
    const unique = [...new Set(merged)];

    if (unique.length > 0) {
      unique.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "budget_branch" || doc.id === "budget_branch") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "quantity" || doc.id === "total" || doc.id === "amount") {
                doc.data.push(parseFloat(value || 0));
              } else {
                doc.data.push(value ?? "-");
              }
            } else {
              if (key === "budget_acc_trans") {
                // console.log(data);

                let total = data.total ? data.total : 0;
                const realization = dataDoc.find((d) => d.id === "realisasi");
                const remaind = dataDoc.find((d) => d.id === "sisa");
                const kasMasuk = dataDoc.find((d) => d.id === "kas_masuk");
                const kasKeluar = dataDoc.find((d) => d.id === "kas_keluar");
                const sisaPiutang = dataDoc.find((d) => d.id === "sisa_piutang");
                const sisaHutang = dataDoc.find((d) => d.id === "sisa_hutang");

                const valRealization = (data.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
                const valRemaind = parseFloat(total) - parseFloat(valRealization);

                ///masuk
                const valKasMasuk =
                  data.type === "CASH IN"
                    ? currencyFormat(
                      (data.budget_acc_trans || [])
                        .filter((item) => item.type === "CASH IN")
                        .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                        .reduce((prev, curr) => prev + curr, 0),
                    )
                    : "-";

                ///keluar
                const valKasKeluar =
                  data.type === "CASH OUT"
                    ? currencyFormat(
                      (data.budget_acc_trans || [])
                        .filter((item) => item.type === "CASH OUT")
                        .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                        .reduce((prev, curr) => prev + curr, 0),
                    )
                    : "-";

                const valSisaPiutang =
                  data.type === "CASH IN"
                    ? currencyFormat(
                      (data.budget_acc_trans || [])
                        .filter((item) => item.type === "RECEIVABLE")
                        .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                        .reduce((prev, curr) => prev + curr, 0),
                    )
                    : "-";

                const valSisaHutang =
                  data.type === "CASH OUT"
                    ? currencyFormat(
                      (data.budget_acc_trans || [])
                        .filter((item) => item.type === "PAYABLE")
                        .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                        .reduce((prev, curr) => prev + curr, 0),
                    )
                    : "-";

                ///
                realization.data.push(valRealization);
                remaind.data.push(valRemaind);
                kasMasuk.data.push(valKasMasuk);
                kasKeluar.data.push(valKasKeluar);
                sisaPiutang.data.push(valSisaPiutang);
                sisaHutang.data.push(valSisaHutang);

                ///detail
                const nameCol = dataDoc.find((d) => d.id === "name");
                const budgetCol = dataDoc.find((d) => d.id === "budget_branch");
                const qtyCol = dataDoc.find((d) => d.id === "quantity");
                const amountCol = dataDoc.find((d) => d.id === "amount");
                const totalCol = dataDoc.find((d) => d.id === "total");
                ///

                const noDetail = dataDoc.find((d) => d.id === "no_detail");
                const tglDetail = dataDoc.find((d) => d.id === "tgl_detail");
                const jenisDetail = dataDoc.find((d) => d.id === "jenis_detail");
                const tagDetail = dataDoc.find((d) => d.id === "tag_detail");
                const jumlahDetail = dataDoc.find((d) => d.id === "jumlah_detail");
                const descriptionDetail = dataDoc.find((d) => d.id === "description_detail");
                const trans = data?.budget_acc_trans;

                noDetail.data.push(trans?.[0]?.code ?? "");
                tglDetail.data.push(trans.length === 0 ? "" : handleValidDate(trans?.[0]?.transactionat) ?? "");
                jenisDetail.data.push(trans?.[0]?.type ?? "");
                tagDetail.data.push(trans?.[0]?.at_cvl_account?.name || trans?.[0]?.at_legal?.owner || trans?.[0]?.at_cvl_contract?.cvl_contract_cvl_account?.name || (trans?.[0]?.at_purchase?.purchase_detail[0] && trans?.[0]?.at_purchase?.purchase_detail[0]?.cvl_account) || trans?.[0]?.at_tag?.name || "");
                jumlahDetail.data.push(trans.length === 0 ? "" : currencyFormat(trans?.[0]?.amount) ?? "");
                descriptionDetail.data.push(trans?.[0]?.description ?? "");
                if (Array.isArray(trans) && trans.length > 0) {
                  if (trans.length > 1) {
                    for (let i = 1; i < trans.length; i++) {
                      nameCol.data.push("");
                      budgetCol.data.push("");
                      qtyCol.data.push("");
                      amountCol.data.push("");
                      totalCol.data.push("");
                      realization.data.push("");
                      remaind.data.push("");
                      kasMasuk.data.push("");
                      kasKeluar.data.push("");
                      sisaPiutang.data.push("");
                      sisaHutang.data.push("");
                      noDetail.data.push(trans[i].code ?? "");
                      tglDetail.data.push(handleValidDate(trans?.[i]?.transactionat) ?? "");
                      jenisDetail.data.push(trans?.[i]?.type ?? "");
                      tagDetail.data.push(trans?.[i]?.at_cvl_account?.name || trans?.[i]?.at_legal?.owner || trans?.[i]?.at_cvl_contract?.cvl_contract_cvl_account?.name || (trans?.[i]?.at_purchase?.purchase_detail[i] && trans?.[i]?.at_purchase?.purchase_detail[i]?.cvl_account) || trans?.[i]?.at_tag?.name || "");
                      jumlahDetail.data.push(currencyFormat(trans?.[i]?.amount) ?? "");
                      descriptionDetail.data.push(trans[i].description ?? "");
                    }
                  }
                }
              }
            }
          });
        }
      });
    }

    // if (budgetCashOutList.length > 0) {
    //   budgetCashOutList.forEach((data) => {
    //     if (data.isChecked) {
    //       Object.entries(data).forEach(([key, value]) => {
    //         const doc = dataDoc.find((d) => d.id === key);

    //         if (doc) {
    //           if (doc.id === "budget_branch" || doc.id === "budget_branch") {
    //             doc.data.push(value?.name ?? "-");
    //           } else if (doc.id === "quantity" || doc.id === "total" || doc.id === "amount") {
    //             doc.data.push(parseFloat(value || 0));
    //           } else {
    //             doc.data.push(value ?? "-");
    //           }
    //         } else {
    //           if (key === "budget_acc_trans") {
    //             let total = data.total ? data.total : 0;
    //             const realization = dataDoc.find((d) => d.id === "realisasi");
    //             const remaind = dataDoc.find((d) => d.id === "sisa");
    //             const valRealization = (data.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
    //             const valRemaind = parseFloat(total) - parseFloat(valRealization);
    //             realization.data.push(valRealization);
    //             remaind.data.push(valRemaind);
    //           }
    //         }
    //       });
    //     }
    //   });
    // }

    setPrintDoc(dataDoc);
  }, [budgetCashInList, budgetCashOutList]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (infoList.length > 0) {
      infoList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account));

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(currencyFormat(Math.round(data?.amount)));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintDetailDoc(dataDoc);
  }, [infoList]);

  // useEffect(() => {
  //   let dataDoc = init;

  //   if (budgetCashOutList.length > 0) {
  //     budgetCashOutList.forEach((data) => {
  //       if (data.isChecked) {
  //         Object.entries(data).forEach(([key, value]) => {
  //           const doc = dataDoc.find((d) => d.id === key);

  //           if (doc) {
  //             if (doc.id === "budget_branch" || doc.id === "budget_branch") {
  //               doc.data.push(value?.name ?? "-");
  //             } else if (doc.id === "quantity" || doc.id === "total") {
  //               doc.data.push(currencyFormat(parseFloat(value || 0) || 0));
  //             } else {
  //               doc.data.push(value ?? "-");
  //             }
  //           } else {
  //             if (key === "budget_acc_trans") {
  //               let total = data.total ? data.total : 0;
  //               const realization = dataDoc.find((d) => d.id === "realisasi");
  //               const remaind = dataDoc.find((d) => d.id === "sisa");
  //               const valRealization = currencyFormat((data.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0));
  //               const valRemaind = currencyFormat(parseFloat(total - realization, 2));
  //               realization.data.push(valRealization);
  //               remaind.data.push(valRemaind);
  //             }
  //           }
  //         });
  //       }
  //     });
  //   }

  //   setPrintDoc2(dataDoc);
  // }, [budgetCashOutList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredBudgets = budgets;
      if (type !== "all") {
        filteredBudgets = budgets.filter((item) => item.budget_status.name === type);
      }
      toggleBranch("all");
      setBudgetList(filteredBudgets);
    }
  };

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setAccTrans(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      case "imageVarian":
        validation.setFieldValue("imageVarian", file.filename);
        break;
      default:
        setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const toggleBranch = (branch) => {
    let filteredBudgets = budgets;
    if (branch !== "all") {
      filteredBudgets = budgets.filter((item) => item.branchId === branch);
    }

    let arrCashIn = [];
    let arrCashOut = [];
    let tin = 0;
    let trin = 0;
    let tsin = 0;
    let tout = 0;
    let trout = 0;
    let tsout = 0;
    for (const item of filteredBudgets) {
      if (item.type === "CASH IN") {
        arrCashIn.push(item);
        tin += parseFloat(item.total, 2);
        trin += (item.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
        tsin += parseFloat(item.total) - (item.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
      } else {
        arrCashOut.push(item);
        tout += parseFloat(item.total, 2);
        trout += (item.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
        tsout += parseFloat(item.total) - (item.budget_acc_trans || []).map((el) => parseFloat(el.amount || 0)).reduce((prev, curr) => prev + curr, 0);
      }
    }
    setBudgetList(budgets);
    setTotalCashIn(tin);
    setTotalRealizationIn(trin);
    setTotalSaldoIn(tsin);
    setTotalCashOut(tout);
    setTotalRealizationOut(trout);
    setTotalSaldoOut(tsout);
    setBudgetCashInList(arrCashIn);
    setBudgetCashOutList(arrCashOut);
  };

  const handleCheckAll = () => {
    const allInChecked = budgetCashInList.every((item) => item.isChecked);
    const allOutChecked = budgetCashOutList.every((item) => item.isChecked);

    const shouldCheck = !(allInChecked && allOutChecked);
    setBudgetCashInList((prev) => prev.map((item) => ({ ...item, isChecked: shouldCheck })));
    setBudgetCashOutList((prev) => prev.map((item) => ({ ...item, isChecked: shouldCheck })));
  };

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
        if (id === 1 && companySelected && companySelected.value) {
          setBranchValue(obj);
        }
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(uoms)) {
      var data = [];
      var opt = [];
      uoms.forEach((item, key) => {
        const uom_name = item.name;
        const id = item.id;
        var obj = { label: uom_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setUomList(data);
    }
  }, [uoms]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setBudget(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handleBudgetClick = useCallback(
    (arg, edit) => {
      const budget = arg;

      let files = [];
      for (const f of budget.budget_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setAssetFiles(files);

      setBudget({
        id: budget.id,
        name: budget.name,
        amount: budget.amount,
        quantity: budget.quantity,
        total: budget.total,
        code: budget.code,
        sinceat: budget.sinceat,
        description: budget.description,
        status: budget.budget_status.id,
        file: budget.budget_file,
        uom: budget.budget_uom && {
          label: budget.budget_uom.name,
          value: budget.budget_uom.id,
        },
        type: budget.type && {
          label: budget.type,
          value: budget.type,
        },
        company: {
          label: budget.budget_company ? budget.budget_company.name : "",
          value: budget.budget_company ? budget.budget_company.id : "",
        },
        client: {
          label: budget.budget_client ? budget.budget_client.name : "",
          value: budget.budget_client ? budget.budget_client.id : "",
        },
        parent: budget.budget_parent && {
          label: budget.budget_parent ? budget.budget_parent.name : "",
          value: budget.budget_parent ? budget.budget_parent.id : "",
        },
        branch: budget.budget_branch === null ? "" : { label: budget.budget_branch.name, value: budget.budget_branch.id },
      });

      setIsEdit(edit);
      toggle();
    },
    [toggle, userType],
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (budget && budget.client) || clientSelected,
      company: (budget && budget.company) || companySelected,
      name: (budget && budget.name) ?? "",
      code: (budget && budget.code) ?? "",
      amount: (budget && budget.amount) ?? "",
      quantity: (budget && budget.quantity) ?? "",
      total: (budget && budget.total) ?? "",
      uom: (budget && budget.uom) ?? "",
      type: (budget && budget.type) ?? "",
      status: (budget && budget.status) || "1",
      description: (budget && budget.description) ?? "",
      branch: (budget && budget.branch) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Budget Name"),
      client: Yup.object().required("Silahkan isi grup perusahaan"),
      company: Yup.object().required("Please Select Company"),
      branch: Yup.object().required("Please Select Branch"),
    }),
    onSubmit: (values) => {
      dispatch(getBudgetLoading());
      if (isEdit) {
        const updateBudget = {
          id: budget ? budget.id : 0,
          name: values.name,
          code: values.code,
          quantity: values.quantity,
          amount: values.amount,
          type: values.type.value,
          branchId: values.branch.value,
          uom: values.uom.value,
          description: values.description,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
          files: assetFiles.length > 0 ? assetFiles : [],
        };
        dispatch(onUpdateBudget(updateBudget));
        validation.resetForm();
      } else {
        const newBudget = {
          name: values.name,
          code: values.code,
          quantity: values.quantity,
          amount: values.amount,
          type: values.type.value,
          branchId: values.branch.value,
          uom: values.uom.value,
          description: values.description,
          statusId: values.status,
          clientId: values.client.value,
          companyId: values.company.value,
          files: assetFiles.length > 0 ? assetFiles : [],
        };
        dispatch(onAddNewBudget(newBudget));
        validation.resetForm();
      }
      toggle();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteBudget(element.value));
    });
    checkall.checked = false;
  };

  const checkedAll = () => {
    const allChecked = budgetCashInList.every((item) => item.isChecked);
    const updatedData = budgetCashInList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setBudgetCashInList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        width: 2,
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={budgetCashInList.every((item) => item.isChecked)} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = budgetCashInList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setBudgetCashInList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateBudget") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      handleBudgetClick(data, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("createBudget") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      handleBudgetClick(data, false);
                    }}
                  >
                    <i className="ri-file-copy-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteBudget") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Budget",
        accessor: "name",
        width: 15,
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          switch (data.budget_status.name) {
            case "DRAFT":
              return (
                <div
                  className="text-warning cursor-pointer"
                  style={{ width: "290px" }}
                  onClick={() => {
                    setInfo(data);
                    const dataDetailList = data.budget_acc_trans;
                    dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

                    setInfoList(dataDetailList);
                    toggleHistory();
                  }}
                >
                  <p className="fw-semibold mb-1">
                    {data.code || "-"}. {cell.value}
                  </p>
                  <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
                </div>
              );
            case "ACTIVE":
              return (
                <div
                  className="text-dark cursor-pointer"
                  style={{ width: "290px" }}
                  onClick={() => {
                    setInfo(data);
                    const dataDetailList = data.budget_acc_trans;
                    dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                    setInfoList(dataDetailList);
                    toggleHistory();
                  }}
                >
                  <p className="fw-semibold mb-1">
                    {data.code || "-"}. {cell.value}
                  </p>
                  <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
                </div>
              );
            default:
              return (
                <div
                  className="text-danger cursor-pointer"
                  style={{ width: "290px" }}
                  onClick={() => {
                    setInfo(data);
                    const dataDetailList = data.budget_acc_trans;
                    dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                    setInfoList(dataDetailList);
                    toggleHistory();
                  }}
                >
                  <p className="fw-semibold mb-1">
                    {data.code || "-"}. {cell.value}
                  </p>
                  <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
                </div>
              );
          }
        },
      },
      {
        id: "Description",
        Header: "Keterangan",
        accessor: "description",
        width: 20,
        filterable: true,
      },
      {
        Header: "Proyek",
        accessor: "budget_branch.branch_code",
        width: 5,
        filterable: true,
        Cell: (cell) => {
          return (
            <div className="fw-semibold" style={{ textAlign: "left" }}>
              {cell.value}
            </div>
          );
        },
      },
      {
        id: "Satuan",
        Header: "Satuan",
        accessor: "budget_uom.name",
        width: 3,
        filterable: true,
      },
      {
        Header: (
          <div style={{ textAlign: "left" }} className="">
            Qty
          </div>
        ),
        accessor: "quantity",
        width: 6,
        filterable: true,
        Cell: (cell) => {
          return (
            <div style={{ textAlign: "left" }}>
              <span className="fw-semibold">{parseFloat(cell.value, 2)}</span> <em className="fs-11">{cell.row.original.budget_uom && cell.row.original.budget_uom.name}</em>
            </div>
          );
        },
      },
      {
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Harga
          </div>
        ),
        accessor: "amount",
        width: 10,
        filterable: true,
        Cell: (cell) => {
          return (
            <div className="fw-semibold" style={{ textAlign: "right" }}>
              {currencyFormat(parseFloat(cell.value) || 0)}
            </div>
          );
        },
      },
      {
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Total
          </div>
        ),
        filterable: true,
        width: 10,
        accessor: "total",
        Cell: (cell) => {
          return (
            <div className="fw-semibold text-primary" style={{ textAlign: "right" }}>
              {currencyFormat(parseFloat(cell.value) || 0)}
            </div>
          );
        },
      },
      {
        id: "Masuk",
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Kas Masuk
          </div>
        ),
        filterable: true,
        width: 10,
        Cell: (cell) => {
          let data = cell.row.original;
          return (
            <div
              className="fw-semibold text-success"
              style={{ textAlign: "right", cursor: "pointer" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              {currencyFormat(
                (data.budget_acc_trans || [])
                  .filter((item) => item.type === "CASH IN")
                  .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                  .reduce((prev, curr) => prev + curr, 0),
              )}
            </div>
          );
        },
      },
      {
        id: "Piutang",
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Sisa Piutang
          </div>
        ),
        filterable: true,
        width: 10,
        Cell: (cell) => {
          let data = cell.row.original;
          return (
            <div
              className="fw-semibold text-danger"
              style={{ textAlign: "right", cursor: "pointer" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              {currencyFormat(
                (data.budget_acc_trans || [])
                  .filter((item) => item.type === "RECEIVABLE")
                  .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                  .reduce((prev, curr) => prev + curr, 0),
              )}
            </div>
          );
        },
      },
      {
        id: "realisasi",
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Total Realisasi
          </div>
        ),
        filterable: true,
        width: 10,
        Cell: (cell) => {
          let data = cell.row.original;
          return (
            <div
              className="fw-semibold text-info"
              style={{ textAlign: "right", cursor: "pointer" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              {currencyFormat(
                (data.budget_acc_trans || [])
                  .filter((item) => item.type === "CASH IN")
                  .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                  .reduce((prev, curr) => prev + curr, 0) +
                (data.budget_acc_trans || [])
                  .filter((item) => item.type === "RECEIVABLE")
                  .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
                  .reduce((prev, curr) => prev + curr, 0),
              )}
            </div>
          );
        },
      },
      {
        id: "sisa",
        Header: (
          <div style={{ textAlign: "right" }} className="me-3">
            Sisa
          </div>
        ),
        filterable: true,
        width: 10,
        Cell: (cell) => {
          let data = cell.row.original;
          let realization =
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "CASH IN")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0) +
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "RECEIVABLE")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0);
          let total = data.total ? data.total : 0;
          return (
            <div
              className="fw-semibold fs-13"
              style={{
                textAlign: "right",
              }}
            >
              {currencyFormat(parseFloat(total - realization, 2))}
            </div>
          );
        },
      },
      {
        id: "Status",
        Header: "Status",
        width: 5,
        accessor: "budget_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [budgetCashInList, handleBudgetClick],
  );

  const defaultdate = () => {
    return moment(new Date()).tz("Asia/Jakarta").format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  //TABLE
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: budgetCashInList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Description", "Status", "Satuan"],
        pageIndex: 0,
        pageSize: 100000,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  const checkedAllSecond = () => {
    const allChecked = budgetCashOutList.every((item) => item.isChecked);
    const updatedData = budgetCashOutList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setBudgetCashOutList(updatedData);
  };

  const columnsSecond = useMemo(() => [{
    id: "#",
    width: 2,
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={budgetCashOutList.every((item) => item.isChecked)} onChange={checkedAllSecond} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0 cursor-pointer">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = budgetCashOutList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setBudgetCashOutList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateBudget") !== -1 ? "btn-sm" : "d-none"}
                onClick={() => {
                  handleBudgetClick(data, true);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("createBudget") !== -1 ? "btn-sm" : "d-none"}
                onClick={() => {
                  handleBudgetClick(data, false);
                }}
              >
                <i className="ri-file-copy-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteBudget") !== -1 ? "btn-sm" : "d-none"}
                onClick={() => {
                  onClickDelete(data);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
  },
  {
    Header: "Budget",
    accessor: "name",
    width: 15,
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      switch (data.budget_status.name) {
        case "DRAFT":
          return (
            <div
              className="text-warning cursor-pointer"
              style={{ width: "290px" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              <p className="fw-semibold mb-1">
                {data.code || "-"}. {cell.value}
              </p>
              <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
            </div>
          );
        case "ACTIVE":
          return (
            <div
              className="text-dark cursor-pointer"
              style={{ width: "290px" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              <p className="fw-semibold mb-1">
                {data.code || "-"}. {cell.value}
              </p>
              <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
            </div>
          );
        default:
          return (
            <div
              className="text-danger cursor-pointer"
              style={{ width: "290px" }}
              onClick={() => {
                setInfo(data);
                const dataDetailList = data.budget_acc_trans;
                dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
                setInfoList(dataDetailList);
                toggleHistory();
              }}
            >
              <p className="fw-semibold mb-1">
                {data.code || "-"}. {cell.value}
              </p>
              <p className="text-wrap">{data.description.trim() !== "" ? "" + data.description : ""} </p>
            </div>
          );
      }
    },
  },
  {
    id: "Description",
    Header: "Keterangan",
    accessor: "description",
    width: 20,
    filterable: true,
  },
  {
    Header: "Proyek",
    accessor: "budget_branch.branch_code",
    width: 5,
    filterable: true,
    Cell: (cell) => {
      return (
        <div className="fw-semibold" style={{ textAlign: "left" }}>
          {cell.value}
        </div>
      );
    },
  },
  {
    id: "Satuan",
    Header: "Satuan",
    accessor: "budget_uom.name",
    width: 3,
    filterable: true,
  },
  {
    Header: (
      <div style={{ textAlign: "left" }} className="">
        Qty
      </div>
    ),
    accessor: "quantity",
    width: 6,
    filterable: true,
    Cell: (cell) => {
      return (
        <div style={{ textAlign: "left" }}>
          <span className="fw-semibold">{parseFloat(cell.value, 2)}</span> <em className="fs-11">{cell.row.original.budget_uom && cell.row.original.budget_uom.name}</em>
        </div>
      );
    },
  },
  {
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Harga
      </div>
    ),
    accessor: "amount",
    width: 10,
    filterable: true,
    Cell: (cell) => {
      return (
        <div className="fw-semibold" style={{ textAlign: "right" }}>
          {currencyFormat(parseFloat(cell.value) || 0)}
        </div>
      );
    },
  },
  {
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Total
      </div>
    ),
    filterable: true,
    width: 10,
    accessor: "total",
    Cell: (cell) => {
      return (
        <div className="fw-semibold text-primary" style={{ textAlign: "right" }}>
          {currencyFormat(parseFloat(cell.value) || 0)}
        </div>
      );
    },
  },
  {
    id: "Keluar",
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Kas Keluar
      </div>
    ),
    filterable: true,
    width: 10,
    Cell: (cell) => {
      let data = cell.row.original;
      return (
        <div
          className="fw-semibold text-success"
          style={{ textAlign: "right", cursor: "pointer" }}
          onClick={() => {
            setInfo(data);
            const dataDetailList = data.budget_acc_trans;
            dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
            setInfoList(dataDetailList);
            toggleHistory();
          }}
        >
          {currencyFormat(
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "CASH OUT")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0),
          )}
        </div>
      );
    },
  },
  {
    id: "Hutang",
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Sisa Hutang
      </div>
    ),
    filterable: true,
    width: 10,
    Cell: (cell) => {
      let data = cell.row.original;
      return (
        <div
          className="fw-semibold text-danger"
          style={{ textAlign: "right", cursor: "pointer" }}
          onClick={() => {
            setInfo(data);
            const dataDetailList = data.budget_acc_trans;
            dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
            setInfoList(dataDetailList);
            toggleHistory();
          }}
        >
          {currencyFormat(
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "PAYABLE")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0),
          )}
        </div>
      );
    },
  },
  {
    id: "realisasi",
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Total Realisasi
      </div>
    ),
    filterable: true,
    width: 10,
    Cell: (cell) => {
      let data = cell.row.original;
      return (
        <div
          className="fw-semibold text-info"
          style={{ textAlign: "right", cursor: "pointer" }}
          onClick={() => {
            setInfo(data);
            const dataDetailList = data.budget_acc_trans;
            dataDetailList.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));
            setInfoList(dataDetailList);
            toggleHistory();
          }}
        >
          {currencyFormat(
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "CASH OUT")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0) +
            (data.budget_acc_trans || [])
              .filter((item) => item.type === "PAYABLE")
              .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
              .reduce((prev, curr) => prev + curr, 0),
          )}
        </div>
      );
    },
  },
  {
    id: "sisa",
    Header: (
      <div style={{ textAlign: "right" }} className="me-3">
        Sisa
      </div>
    ),
    filterable: true,
    width: 10,
    Cell: (cell) => {
      let data = cell.row.original;
      let realization =
        (data.budget_acc_trans || [])
          .filter((item) => item.type === "CASH OUT")
          .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
          .reduce((prev, curr) => prev + curr, 0) +
        (data.budget_acc_trans || [])
          .filter((item) => item.type === "PAYABLE")
          .map((el) => parseFloat(el.amount - (el.paid_amount || 0)))
          .reduce((prev, curr) => prev + curr, 0);
      let total = data.total ? data.total : 0;
      return (
        <div
          className={total - realization > 0 ? "fw-semibold fs-13" : "fw-semibold text-danger fs-13"}
          style={{
            textAlign: "right",
          }}
        >
          {currencyFormat(parseFloat(total - realization, 2))}
        </div>
      );
    },
  },
  {
    id: "Status",
    Header: "Status",
    width: 5,
    accessor: "budget_status.name",
    filterable: true,
    Cell: (cell) => {
      switch (cell.value) {
        case "DRAFT":
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        case "ACTIVE":
          return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
        case "INACTIVE":
          return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
        default:
          return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
      }
    },
  },
  ],
    [budgetCashOutList, handleBudgetClick],
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    footerGroups: footerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: budgetCashOutList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Description", "Status", "Satuan"],
        pageIndex: pIndexSecond,
        pageSize: 100000,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const [branchValue, setBranchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
    setGlobalFilterSecond(value || undefined);
  }, 200);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetBudgets(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setBudgetCashInList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterSecond(undefined);

    dispatch(resetBudgetState());
    dispatch(onGetBudgets({ companyId: companySelected?.value ?? "", branchId: branchSelected?.value ?? "" }));
    handleGetUOM(companySelected?.value ?? "");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    setPIndexSecond(pageIndexSecond);
  }, [pageIndexSecond]);

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter(
        (el) =>
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          el.amount.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          el.description.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          handleValidDate(el.transactionat).toLowerCase().indexOf(query.toLowerCase()) !== -1,
      );
    };

    let filterData = filterItems(info.budget_acc_trans, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setInfoList(filterData);
  };

  const handleAccTransClick = useCallback(
    (arg) => {
      const data = arg;
      setAccTrans(data);
      toggleDetail();
    },
    [toggleDetail, userType],
  );

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  document.title = "Cashflow | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={budgetList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBudget} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="CASHFLOW" pageTitle="ANGGARAN CASHFLOW" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-1" : userRole && userRole.split(",").indexOf("createBudget") !== -1 ? "btn btn-primary add-btn me-1" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            {/* <button className={userType === "admin" || userType === "client" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteBudget") !== -1 ? "btn btn-soft-danger" : "d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>
            </button> */}

            {/* <ExportBudgetDoc data={typeBudget.value === "CASH IN" ? printDoc : printDoc2}>
              <Select
                className="mb-2"
                name="type"
                placeholder="Pilih Jenis Anggaran"
                value={typeBudget}
                onChange={(e) => {
                  setTypeBudget(e);
                }}
                options={transTypeData}
              ></Select>
            </ExportBudgetDoc> */}
            <ExportDoc data={printDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xl={3} md={6}>
            <Card className="card-animate bg-soft-info">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase text-muted fs-12 mb-1">Penerimaan</p>
                    <h3 className="mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={totalCashIn} decimals={0} duration={2} />
                    </h3>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate bg-soft-success">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase text-muted fs-12 mb-1">Realisasi Penerimaan</p>
                      </div>
                      <div className="flex-shrink-0">
                        <h5 className={"fs-13 mb-0 text-success"}>
                          <i className={"fs-10 align-middle ri-arrow-right-up-line"}></i> {parseFloat((totalRealizationIn / totalCashIn) * 100).toFixed(2)} %
                        </h5>
                      </div>
                    </div>
                    <h3 className="mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={totalRealizationIn} decimals={0} duration={2} />
                    </h3>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate bg-soft-warning">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-3">
                    <p className="text-uppercase text-muted fs-12 mb-1">Pengeluaran</p>
                    <h3 className="mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={totalCashOut} decimals={0} duration={2} />
                    </h3>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate bg-soft-danger">
              <CardBody>
                <div className="d-flex align-items-center ">
                  <div className="flex-grow-1 ms-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 overflow-hidden">
                        <p className="text-uppercase text-muted fs-12 mb-1">Realisasi Pengeluaran</p>
                      </div>
                      <div className="flex-shrink-0">
                        <h5 className={"fs-13 mb-0 text-danger"}>
                          <i className={"fs-10 align-middle ri-arrow-right-up-line"}></i>
                          {parseFloat((totalRealizationOut / totalCashOut) * 100).toFixed(2)} %
                        </h5>
                      </div>
                    </div>
                    <h3 className="mb-0">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={totalRealizationOut} decimals={0} duration={2} />
                    </h3>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Card id="budgetList">
              <CardBody className="pt-1 pb-2">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL BUDGET
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#" >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row>
                    <CardBody className="pb-0">
                      <form>
                        <Row>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${budgetList.length} Cari Pos Anggaran...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                value={filterDate}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                </div>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={budgetCashInList.every((item) => item.isChecked) && budgetCashOutList.every((item) => item.isChecked)} onChange={handleCheckAll} /> <span className="ms-1">Pilih semua anggaran cashflow (penerimaan dan pengeluaran kas)</span>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Card className="mt-3">
              <CardHeader className="bg-soft-success">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="text-uppercase fw-semibold fs-16 mb-0">PENERIMAAN KAS</p>
                  </div>
                  <div className="flex-shrink-0">
                    <h5 className={"fs-14 mb-0 text-dark"}>
                      Estimasi Profit: <span className="fw-semibold fs-4 ms-3"> {currencyFormat(totalCashIn - totalCashOut)} </span>
                    </h5>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pb-0">
                <div className="table-responsive table-card mb-0">
                  <Table hover {...getTableProps()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()} style={{ width: column.width + "%" }}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="border-0" colSpan={5}></td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-primary pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalCashIn)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-success pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalIn)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-danger pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalRealizationIn - totalIn)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-info pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalRealizationIn)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-success pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalSaldoIn)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
            </Card>
            <Card className="mt-3">
              <CardHeader className="bg-soft-danger fw-semibold fs-16">PENGELUARAN KAS</CardHeader>
              <CardBody className="pb-0">
                <div className="table-responsive table-card mb-0">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()} style={{ width: column.width + "%" }}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="border-0" colSpan={5}></td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-primary pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalCashOut)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-success pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalOut)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-danger pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalRealizationOut - totalOut)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-info pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalRealizationOut)}
                        </td>
                        <td style={{ textAlign: "right" }} className="fs-14 fw-semibold text-right text-success pt-3 pb-3 pe-2 border-0">
                          Rp {currencyFormat(totalSaldoOut)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal id="showModal" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>
            {!!isEdit ? "Edit Pos Anggaran" : "Tambah Pos Anggaran"}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              <div className="row">
                <div className="col-lg-4">
                  <div className="mb-3">
                    <Label htmlFor="client" className="form-label">
                      CLient
                      {clientLoading && (
                        <Spinner color="primary" size="sm">
                          Loading...
                        </Spinner>
                      )}
                    </Label>
                    <Select
                      name="client"
                      value={validation.values.client}
                      isDisabled={userType === "admin" || userType === "client" ? false : true}
                      placeholder="Pilih Grup Usaha"
                      onChange={(e) => {
                        dispatch(setClientSelect(e));
                        validation.setFieldValue("parent", "");
                        setCompanyList([]);
                        validation.setFieldValue("company", "");
                        setBranchList([]);
                        validation.setFieldValue("branch", "");
                        validation.setFieldValue("client", e);
                        handleGetUOM(e.value);
                      }}
                      options={clientList}
                    ></Select>
                    {validation.touched.client && validation.errors.client ? (
                      <p className="text-danger" type="invalid">
                        {validation.errors.client}
                      </p>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="company" className="form-label">
                      Company
                      {companyLoading && (
                        <Spinner color="primary" size="sm">
                          Loading...
                        </Spinner>
                      )}
                    </Label>
                    <Select
                      name="company"
                      value={validation.values.company}
                      placeholder="Pilih Perusahaan"
                      isDisabled={userType === "admin" || userType === "client" ? false : true}
                      onChange={(e) => {
                        setBranchList([]);
                        dispatch(setCompanySelect(e));
                        validation.setFieldValue("parent", "");
                        validation.setFieldValue("branch", "");
                        validation.setFieldValue("company", e);
                      }}
                      options={companyList}
                    ></Select>
                    {validation.touched.company && validation.errors.company ? (
                      <p className="text-danger" type="invalid">
                        {validation.errors.company}
                      </p>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="branch" className="form-label">
                      Proyek
                    </Label>
                    <Select
                      name="branch"
                      value={validation.values.branch}
                      placeholder="Pilih Proyek"
                      onChange={(e) => {
                        validation.setFieldValue("branch", e);
                      }}
                      options={branchList}
                    ></Select>
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="name-field" className="form-label">
                      Nama Anggaran
                    </Label>
                    <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Anggaran" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                    {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="code-field" className="form-label">
                      Kode Anggaran
                    </Label>
                    <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode Anggaran" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                    {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="mb-3">
                    <Label htmlFor="type" className="form-label">
                      Jenis Anggaran
                    </Label>
                    <Select
                      name="type"
                      placeholder="Pilih Jenis Anggaran"
                      value={validation.values.type}
                      onChange={(e) => {
                        validation.setFieldValue("type", e);
                      }}
                      options={transTypeData}
                    ></Select>
                    {validation.touched.type && validation.errors.type && (
                      <small className="text-danger" type="invalid">
                        {validation.errors.type}
                      </small>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="weight">
                      Satuan Ukur
                    </label>
                    <Select
                      name="uom"
                      placeholder="Isi Satuan Ukur"
                      value={validation.values.uom}
                      onChange={(e) => {
                        validation.setFieldValue("uom", e);
                      }}
                      options={uomList}
                    ></Select>
                    {validation.touched.uom && validation.errors.uom && (
                      <small className="text-danger" type="invalid">
                        {validation.errors.uom}
                      </small>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="quantity-field" className="form-label">
                      Jumlah
                    </Label>
                    <Input name="quantity" id="quantity-field" className="form-control" placeholder="Isi Jumlah" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.quantity} invalid={validation.touched.quantity && validation.errors.quantity ? true : false} />
                    {validation.touched.quantity && validation.errors.quantity ? <FormFeedback type="invalid">{validation.errors.quantity}</FormFeedback> : null}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="amount-field" className="form-label">
                      Nilai
                    </Label>
                    <Input name="amount" id="amount-field" className="form-control" placeholder="Enter Nilai" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.amount} invalid={validation.touched.amount && validation.errors.amount ? true : false} />
                    {validation.touched.amount && validation.errors.amount ? <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback> : null}
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="active-status" className="form-label">
                      Status
                    </Label>
                    <Input name="status" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.status}>
                      {statusActiveData.map((item, key) => (
                        <React.Fragment key={key}>
                          {item.options.map((item, key) => (
                            <option value={item.value} key={key}>
                              {item.label}
                            </option>
                          ))}
                        </React.Fragment>
                      ))}
                    </Input>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="mb-3 d-flex justify-content-between">
                    <Label htmlFor="taskFiles" className="form-label me-3">
                      File Anggaran
                    </Label>
                    <button
                      type="button"
                      className="btn btn-sm btn-label btn-soft-success"
                      onClick={() => {
                        setMediaType("files");
                        toggleMedia();
                      }}
                    >
                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                    </button>
                  </div>
                  {assetFiles.map((file, i) => {
                    if (file.isDeleted) {
                      return null;
                    } else {
                      return (
                        <div key={i} className="border-bottom mb-3">
                          <div className="d-flex justify-content-between mb-3 align-items-center">
                            <div
                              onClick={() => {
                                const typeFile = file.filename.split(".");
                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                } else {
                                  //
                                }
                              }}
                            >
                              {renderIcon(file.filename)}

                              <div className="text-truncate">{file.originalname}</div>
                            </div>
                            <div>
                              <Link
                                to="#"
                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                onClick={(e) => {
                                  handleDeleteFile(file);
                                }}
                              >
                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                  <div className="mb-3">
                    <Label htmlFor="des-field" className="form-label">
                      Keterangan
                    </Label>
                    <Input name="description" id="des-field" className="form-control" rows={5} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                  </div>
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    toggle();
                  }}
                >
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">{!!isEdit ? "Update Pos Anggaran" : "Simpan Pos Anggaran"}</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            Invoice Detail
          </ModalHeader>
          {accTrans !== undefined && accTrans !== null ? (
            <ModalBody>
              <Row id="printThis">
                <Col lg={12}>
                  <CardHeader className="border-bottom-dashed p-4">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="80" />
                        <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="80" />
                        <div className="mt-sm-3 mt-3">
                          <h5 className="text-uppercase fw-semibold">{accTrans.at_client && accTrans.at_client.name}</h5>
                          <p className=" mb-1 text-uppercase fw-semibold">{accTrans.at_branch && accTrans.at_branch.name}</p>
                          <p className=" mb-1 text-uppercase">Department: {accTrans.at_department ? accTrans.at_department.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Anggaran Teknik: {accTrans.at_cvl_account ? accTrans.at_cvl_account.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Metode Bayar: {accTrans.at_pm ? accTrans.at_pm.name : "-"}</p>
                          <p className=" mb-1 text-uppercase">Tag: {accTrans.at_tag ? accTrans.at_tag.name : "-"}</p>
                        </div>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="p-4">
                    <Row className="g-3">
                      <Col lg={6} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">No Transaksi</p>
                        <h5 className="fs-14 mb-0">
                          #<span id="invoice-no">{accTrans.transaction_no}</span>
                        </h5>
                      </Col>
                      <Col lg={6} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Date / Due Date</p>
                        <h5 className="fs-14 mb-0">
                          <span id="invoice-date">
                            {handleValidDate(accTrans.transactionat)} / {handleValidDate(accTrans.dueat)}
                          </span>
                        </h5>
                      </Col>
                      <Col lg={12} xs={12}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Jumlah Pembayaran</p>
                        <h5 className="fs-18 mb-0">
                          <span id="total-amount">{currencyFormat(accTrans.amount)}</span>
                        </h5>
                      </Col>
                      <Col lg={12} xs={12}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">Terbilang</p>
                        <h5 className="fs-12 mb-0">
                          <span id="total-amount fs-14">{numberToWords(accTrans.amount)}</span>
                        </h5>
                      </Col>
                    </Row>
                  </CardBody>
                  {accTrans.at_purchase && accTrans.at_purchase.purchase_detail && (
                    <CardBody className="p-4">
                      <Table className="table-borderless text-center table-nowrap align-middle">
                        <thead>
                          <tr className="table-active">
                            <th scope="col" style={{ width: "30px" }}>
                              #
                            </th>
                            <th scope="col" className="text-start">
                              Detail Produk
                            </th>
                            <th scope="col" className="text-start">
                              Anggaran
                            </th>
                            <th scope="col">Harga</th>
                            <th scope="col">Jumlah</th>
                            <th scope="col">Penerimaan Barang</th>
                            <th scope="col" className="text-end">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          {(accTrans.at_purchase.purchase_detail || []).map((o, i) => {
                            return (
                              <tr key={i} id={i} className="product">
                                <th scope="row" className="product-id">
                                  {i + 1}
                                </th>
                                <td className="text-start">{o.name}</td>
                                <td className="text-start">{o.cvl_account}</td>
                                <td>Rp{currencyFormat(o.amount)}</td>
                                <td>{currencyFormat(o.quantity)}</td>
                                <td>{o.accepted}</td>
                                <td className="text-end">Rp{currencyFormat(o.amount * o.quantity)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  )}
                  <CardBody className="p-4">
                    <div className="mt-0 mb-5">
                      <div className="alert alert-item bg-soft-accTrans">
                        <p className="mb-0">
                          <span className="fw-semibold fs-16">NOTES:</span>
                          <span id="note" className="fs-14">
                            {accTrans.description}
                          </span>
                        </p>
                      </div>
                    </div>
                    <Row className="g-3">
                      <Col lg={6} xs={6}>
                        <p className="mb-0 text-center">Bogor, {handleValidDate(accTrans.createdat)}</p>
                        <p className="mb-0 text-center">Pengajuan</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{accTrans.at_createdby ? accTrans.at_createdby.name : ""}</p>
                        <p className="mt-5 text-center">................................</p>
                      </Col>
                      <Col lg={6} xs={6}>
                        <p className="mb-0 text-center">{accTrans.approvedat && handleValidDate(accTrans.approvedat)}</p>
                        <p className="mb-0 text-center">Disetujui Oleh</p>
                        <p className="mb-5 pb-3 fw-semibold text-center">{accTrans.at_approvedby ? accTrans.at_approvedby.name : ""}</p>
                        <p className="mt-5 text-center">................................</p>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardBody className="p-4">
                    <Row className="g-3">
                      {(accTrans.at_file || []).map((f, i) => {
                        if (f.isDeleted) {
                          return null;
                        } else {
                          return (
                            <Col lg={3} xs={3} key={i}>
                              {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                              ) : (
                                <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                  <i className="ri-file-pdf-line fs-16 text-danger"></i>
                                </Link>
                              )}
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  </CardBody>
                </Col>
              </Row>
            </ModalBody>
          ) : null}
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  toggleDetail();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
        <Modal id="showModalHistory" isOpen={modalHistory} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
            {info.name}
          </ModalHeader>
          <ModalBody>
            <div className="table-responsive">
              {info.budget_file && info.budget_file.length > 0 && (
                <>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Dokumen Anggaran</p>
                  <table className="table align-middle table-nowrap mb-3">
                    <tbody id="file-list">
                      {(info.budget_file || []).map((file) => {
                        return (
                          <tr
                            key={file.id + "file"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <input className="form-control filelist-id" type="hidden" value="1" id="filelist-1" />
                              <div className="d-flex align-files-center">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className=" fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 filelist-name">{file.originalname}</div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}

              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold col-sm-5 text-start">
                        <input className="search-box  w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchList(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportDoc data={printDetailDoc} />
                  </div>
                  {/* <Col>
                    {(infoList || []).map((o, i) => {
                      return o.id + ",";
                    })}
                  </Col> */}
                </Row>
                <SimpleBar className="table-container-sticky">
                  <Table className="table-border text-center table-hover table-fixed-header">
                    <thead className="align-middle">
                      <tr className="table-active">
                        <th>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={infoList.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = infoList.every((item) => item.isChecked);
                              const updatedData = infoList.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setInfoList(updatedData);
                            }}
                          />
                        </th>
                        <th className="text-center" style={{ width: "100px" }}>
                          No Transaksi
                        </th>
                        <th className="text-center" style={{ width: "80px" }}>
                          Tanggal
                        </th>
                        <th className="text-center" style={{ width: "80px" }}>
                          Jenis
                        </th>
                        <th className="text-right" style={{ width: "170px" }}>
                          Tag
                        </th>
                        <th className="text-right" style={{ width: "170px" }}>
                          Jumlah Pembayaran
                        </th>
                        <th className="text-center" style={{ width: "200px" }}>
                          Keterangan
                        </th>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {(infoList || []).map((o, i) => {
                        let type;
                        switch (o.type) {
                          case "CASH IN":
                            type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                            break;
                          case "RECEIVABLE":
                            type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                            break;
                          case "CASH OUT":
                            type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                            break;
                          case "PAYABLE":
                            type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                            break;
                          default:
                            type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                            break;
                        }
                        return (
                          <Fragment key={i}>
                            <tr className={o.hasPaid && "bg-soft-success"}>
                              <td style={{ verticalAlign: "middle", width: "30px" }}>
                                <div className="hstack gap-2 mt-4 mt-sm-0">
                                  <input
                                    type="checkbox"
                                    className="checkboxDetail me-2 form-check-input"
                                    checked={o.isChecked}
                                    onChange={() => {
                                      const updatedData = infoList.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                      setInfoList(updatedData);
                                    }}
                                  />
                                  <Button
                                    color="light"
                                    className="btn-sm"
                                    onClick={() => {
                                      handleAccTransClick(o, "detail");
                                    }}
                                  >
                                    <i className="ri-eye-line fs-15"></i>
                                  </Button>
                                </div>
                              </td>
                              <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                {o.transaction_no}
                                {o.hasPaid && <span className="badge text-uppercase badge-soft-success mb-1">LUNAS</span>}
                                {o.statusId === 4 && (
                                  <p className="mb-1">
                                    <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                  </p>
                                )}
                                {o.statusId === 3 && (
                                  <p className="mb-1">
                                    <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                  </p>
                                )}
                                {o.statusId === 2 && (
                                  <p className="mb-1">
                                    <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                  </p>
                                )}
                                {o.statusId === 1 && (
                                  <p className="mb-1">
                                    <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                  </p>
                                )}
                              </td>
                              <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                {handleValidDate(o.transactionat)}
                              </td>
                              <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                {type}
                              </td>
                              <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                              </td>
                              <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                                {currencyFormat(o.amount)}
                              </td>
                              <td className="text-left fs-13" style={{ verticalAlign: "middle" }}>
                                {o.description}
                              </td>
                            </tr>
                          </Fragment>
                        );
                      })}

                      {(infoList || []).length === 0 && (
                        <tr>
                          <td colSpan="7" className="p-3 text-center fs-13">
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
                {info && info.type === "CASH IN" ? (
                  <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                    <div className="col-sm-6 fs-12 text-start">
                      PIUTANG:
                      <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                        {currencyFormat(
                          (infoList || [])
                            .filter((el) => el.type === "RECEIVABLE")
                            .map((el) => parseFloat(el.amount || 0))
                            .reduce((prev, curr) => prev + curr, 0),
                        )}
                      </span>
                    </div>
                    <div className="col-sm-6 fs-12 text-end">
                      PENERIMAAN KAS / BANK :
                      <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                        {currencyFormat(
                          (infoList || [])
                            .filter((el) => el.type !== "RECEIVABLE")
                            .map((el) => parseFloat(el.amount || 0))
                            .reduce((prev, curr) => prev + curr, 0),
                        )}
                      </span>
                    </div>
                  </Row>
                ) : (
                  <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                    <div className="col-sm-6 fs-12 text-start">
                      HUTANG:
                      <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                        {currencyFormat(
                          (infoList || [])
                            .filter((el) => el.type === "PAYABLE")
                            .map((el) => parseFloat(el.amount || 0))
                            .reduce((prev, curr) => prev + curr, 0),
                        )}
                      </span>
                    </div>
                    <div className="col-sm-6 fs-12 text-end">
                      PEMBAYARAN KAS / BANK :
                      <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                        {currencyFormat(
                          (infoList || [])
                            .filter((el) => el.type !== "PAYABLE")
                            .map((el) => parseFloat(el.amount || 0))
                            .reduce((prev, curr) => prev + curr, 0),
                        )}
                      </span>
                    </div>
                  </Row>
                )}
              </div>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalHistory(false);
                }}
              >
                TUTUP
              </button>
            </div>
          </div>
        </Modal>
        <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
      </Container>
    </div>
  );
};

export default Budget;
